import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-notification-service-schema'
import config from './req.config'

export type { paths as NotificationPaths }

export const notificationServiceReq = createFetchClient<paths>({
  ...config,
})

export const notificationServiceQuery = createClient<paths>(notificationServiceReq)
